import PropTypes from 'prop-types'

import { Icon } from '../display/icon'

const LoginIcon = ({ label = 'Login', ...rest }) => {
  return (
    <Icon
      label={label}
      {...rest}
      dangerouslySetGlyph={`<svg data-name="Layer 1" viewBox="0 0 300 300"><path d="M31.2 179.6a8.7 8.7 0 0 0 8.7 8.6h77.7v50.7a4.2 4.2 0 0 0 7.3 3l76.4-77.2a8.6 8.6 0 0 0 0-12.2l-76.4-77.2a4.3 4.3 0 0 0-7.3 3V129H39.9a8.7 8.7 0 0 0-8.7 8.6z" style="fill:#84cee3"/><path d="M121.9 74a4.1 4.1 0 0 1 3 1.3l76.4 77.2a8.6 8.6 0 0 1 0 12.2l-76.4 77.2a4.1 4.1 0 0 1-3 1.3 4.3 4.3 0 0 1-4.3-4.3v-50.7H39.9a8.7 8.7 0 0 1-8.7-8.6v-42a8.7 8.7 0 0 1 8.7-8.6h77.7V78.3a4.3 4.3 0 0 1 4.3-4.3m0-10a14.3 14.3 0 0 0-14.3 14.3V119H39.9a18.7 18.7 0 0 0-18.7 18.6v42a18.7 18.7 0 0 0 18.7 18.6h67.7v40.7A14.3 14.3 0 0 0 132 249l76.4-77.2a18.8 18.8 0 0 0 0-26.4L132 68.2a14.2 14.2 0 0 0-10.1-4.2z" style="fill:#1d1d1b"/><path d="M238.4 247.2H130.6a4.6 4.6 0 0 1-4.6-4.5 4.7 4.7 0 0 1 4.6-4.6h107.8a11.6 11.6 0 0 0 11.6-11.6V89.9a11.7 11.7 0 0 0-11.6-11.7H130.6a4.6 4.6 0 1 1 0-9.1h107.8a20.8 20.8 0 0 1 20.8 20.8v136.6a20.8 20.8 0 0 1-20.8 20.7z" style="fill:#1d1d1b"/></svg>`}
    />
  )
}

LoginIcon.propTypes = {
  onClick: PropTypes.func,
  label: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.oneOf(['tiny', 'small', 'medium', 'large'])
}

export { LoginIcon }
